import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsGuard {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.userDataService.getUserAndCompany();

    if (this.permissionsService.hasCompanyAdminPermissions()) {
      return true;
    }

    this.router.navigateByUrl('/secured/home');
    return false;
  }
}
